export default {
    primaryDark: '#4c47c6',
    primaryLight: '#5d64dd',
    footerLight: '#6e7ff3',
    textLight: 'rgba(255, 255, 255, 0.5)',
    textMedium: '#8491a5',
    textDark: '#262f3c',
    secondary: '#0accbe'
}